import Alert from 'antd/lib/alert'
require('antd/lib/alert/style')
import styled from 'styled-components'
import { Colors } from '../../Themes'

const INFO = 'info'
const ERROR = 'error'
const WARNING = 'warning'

const COLORS = {
  [INFO]: {
    border: Colors.paleGrey,
    background: Colors.aliceBlue,
    text: Colors.warmGrey,
    icon: Colors.warmGrey
  },
  [WARNING]: {
    border: Colors.warning,
    background: Colors.warningLight,
    text: Colors.greyishBrown,
    icon: Colors.apricot
  },
  [ERROR]: {
    border: Colors.salmonCream,
    background: Colors.salmonLight,
    text: Colors.warmGrey,
    icon: Colors.salmon
  }
}

const FONTSIZES = {
  [INFO]: { text: '12px', icon: '13px' },
  [WARNING]: {
    text: '14px',
    icon: '16px'
  },
  [ERROR]: {
    text: '14px',
    icon: '16px'
  }
}
const NUMBERS = {
  [INFO]: {
    alertHeight: 'auto',
    noIconPadding: '10px 16px',
    iconPosition: '14px'
  },
  [WARNING]: {
    alertHeight: 'auto',
    iconPosition: '18px'
  },
  [ERROR]: {
    alertHeight: 'auto',
    iconPosition: '15px'
  }
}

const getFontSize = (type, attr) => FONTSIZES[type || [INFO]][attr]
const getColor = (type, attr) => COLORS[type || [INFO]][attr]
const getSize = (type, attr) => NUMBERS[type || [INFO]][attr]

const StyledAlert = styled(Alert)`
  && {
    padding: ${props => getSize(props.type, 'padding')};
    height: ${props => getSize(props.type, 'alertHeight')};
    border: 1px solid ${props => getColor(props.type, 'border')};
    background-color: ${props => getColor(props.type, 'background')};
    color: ${props => getColor(props.type, 'text')};
    .ant-alert {
      line-height: 1.2;
    }
    span.ant-alert-description {
      font-size: ${props => getFontSize(props.type, 'text')};
    }

    .ant-alert-message {
      font-size: ${props => getFontSize(props.type, 'text')};
    }

    i.ant-alert-icon {
      font-size: ${props => getFontSize(props.type, 'icon')};
      height: ${props => getFontSize(props.type, 'icon')};
      color: ${props => getColor(props.type, 'icon')};
    }
    .ant-alert-close-icon {
      font-size: 12px;
      top: 13px;
    }
    .anticon {
      left: 12px;
    }
  }
`

export default StyledAlert
